(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/products-grid/assets/javascripts/products-grid.js') >= 0) return;  svs.modules.push('/widgets/products-grid/assets/javascripts/products-grid.js'); "use strict";


setGlobal('svs.widget.products_grid.init', svs.sport.productsGridWidget.init);
 })(window);